// extracted by css-extract-rspack-plugin
export default {"root":"root-ExYeGX","container":"container-tovu6B","logo":"logo-UIrftm","title":"title-iNA3Tf text-display-lg","signInButton":"signInButton-Xzggj3"};